<p-confirmDialog></p-confirmDialog>
<h2>Processes of client onboarding registered</h2>
<p-tabMenu [model]="items" [activeItem]="activeItem"/>
<p-table
  [value]="records"
  dataKey="id"
  [paginator]="true"
  [rows]="10"
  [rowsPerPageOptions]="[10, 20, 50]"
  [globalFilterFields]="['customer', 'status']">
  <ng-template pTemplate="caption">
    <div class="flex items-center justify-content-between">
      <p-iconField iconPosition="left">
        <p-inputIcon>
          <i class="pi pi-search"></i>
        </p-inputIcon>
        <input
          pInputText
          type="text"
          (input)="onGlobalFilter($event)"
          placeholder="Search keyword"
        />
      </p-iconField>
      <div class="flex align-items-center gap-2">
        @if (showAddButton) {
          <span
            [pTooltip]="canAdd ? 'Add new customer' : 'You do not have permission to add'"
            tooltipPosition="bottom"
            [style.display]="'inline-block'"
          >
            <p-button
              icon="pi pi-plus"
              [rounded]="true"
              [raised]="true"
              severity="primary"
              [disabled]="!canAdd"
              (onClick)="router.navigate(['billing/client-onboarding/wizard'])"
            />
          </span>
        }
        <p-button
          icon="pi pi-refresh"
          severity="secondary"
          [rounded]="true"
          [raised]="true"
          (onClick)="loadData()"
          pTooltip="Refresh data"
          tooltipPosition="bottom"
        />
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="customerName">
        Customer
        <p-sortIcon field="customerName"/>
      </th>
      <th pSortableColumn="domain">
        Domain
        <p-sortIcon field="domain"/>
      </th>
      <th pSortableColumn="createdAt">
        Created
        <p-sortIcon field="createdAt"/>
      </th>
      <th pSortableColumn="updatedAt">
        Last Updated
        <p-sortIcon field="updatedAt"/>
      </th>
      <th>Progress</th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-record>
    <tr>
      <td>{{ record.customerName }}</td>
      <td>{{ record.domain }}</td>
      <td>{{ record.createdAt | date : 'MMM dd, yyyy, HH:mm' }}</td>
      <td>{{ record.updatedAt | date : 'MMM dd, yyyy, HH:mm' }}</td>
      <td>
        <app-client-onboarding-mini-steps
          [stepsInfo]="record.steps || []"
          [status]="record.status"
          [parentCustomerId]="record.parentCustomerId"
        ></app-client-onboarding-mini-steps>
      </td>
      <td>
        <div class="text-right">
          <span
            *ngIf="record.status === 'IN_PROGRESS'"
            [pTooltip]="canEdit ? (allowEdition ? 'Edit' : 'Info') : 'You do not have permission to edit'"
            [style.display]="'inline-block'"
          >
            <p-button
              class="mr-1"
              [icon]="allowEdition ? 'pi pi-pencil' : 'pi pi-info-circle'"
              [rounded]="true"
              [raised]="true"
              severity="info"
              size="small"
              [disabled]="!canEdit"
              (onClick)="edit(record.id)"
            />
          </span>
          @if (showRemediationButton) {
            <p-button
              class="mr-1"
              icon="pi pi-hammer"
              [rounded]="true"
              [raised]="true"
              severity="primary"
              size="small"
              title="Remediate"
              *ngIf="record.status === 'ERROR'"
              (onClick)="remediate(record.id)"
            />
          }
          <span
            [pTooltip]="canDelete ? 'Disconnect' : 'You do not have permission to delete'"
            [style.display]="'inline-block'"
          >
            <p-button
              icon="pi pi-power-off"
              [rounded]="true"
              [raised]="true"
              severity="danger"
              size="small"
              [disabled]="!canDelete"
              (onClick)="delete(record.id)"
            />
          </span>
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="12" class="text-center py-7">No results found</td>
    </tr>
  </ng-template>
</p-table>
